import logo from './logo.svg';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import './App.css';
import NavBar from "./components/Navbar/NavBar";
import Video from "./components/Video/Video";
import Events from "./components/Events/Events";
import About from "./components/About/About";
import Members from "./components/Members/Members";
import Footer from "./components/Footer/Footer";
import Login from "./components/Login/Login";

import Dashboard from "./components/Dashboard/Dashboard";

function App() {

    let content = {
        English: {
            About: {
                title: "About AGRICOLART",
                text: "AGRICOLART is a farmers’ market in the heart of the Dolomites. It stands for agriculture, for a nature-conscious use of resources and for the knowledge of creating our products as our ancestors taught us.  From bacon to cow or goat cheese, from herbs to honey wine, from flour to “Schnaps”, from ceramics to woodwork, from textiles to honey: Surely something for everyone."
            },
            Events: {
                title: "Upcoming Events",
                eventTile: "AGRICOLART Market",
                atText: "at",
                directions: "Get directions",
                days: "Days",
                hours: "Hours",
                minutes: "Minutes",
                noEvents: "There are no upcoming events."
            },
            Members: {
                title: "Our Members",
                visitWebsite: "Visit their website",
            },
            NavBar: {
                home: "Home",
                upcomingEvents: "Upcoming Events",
                about: "About",
                ourMembers: "Our Members"
            }
        },
        German: {
            About: {
                title: "Über Uns",
                text: "AGRICOLART ist ein Bauernmarkt im Herzen der Dolomiten. Es steht für Landwirtschaft, einen naturbewussten Umgang mit Ressourcen und das Wissen, unsere Produkte so zu kreieren, wie es uns unsere Vorfahren beigebracht haben. Vom Speck bis zum Kuh- oder Ziegenkäse, von Kräutern bis zum Honigwein, von Mehl bis zum Schnaps, von Keramik bis zu Holzarbeiten, von Textilien bis hin zu Honig: Sicherlich ist für jeden etwas dabei."
            },
            Events: {
                title: "Zukünftige Veranstaltungen",
                eventTile: "AGRICOLART Bauernmarkt",
                atText: "in",
                directions: "Wegbeschreibung",
                days: "Tage",
                hours: "Stunden",
                minutes: "Minuten",
                noEvents: "Es gibt keine zukünftige Veranstaltungen."
            },
            Members: {
                title: "Unsere Mitglieder",
                visitWebsite: "Besuche ihre Webseite",
            },
            NavBar: {
                home: "Home",
                upcomingEvents: "Zukünftige Veranstaltungen",
                about: "Über Uns",
                ourMembers: "Unsere Mitglieder"
            }
        },
        Italian: {
            About: {
                title: "Chi Siamo",
                text: "AGRICOLART è un mercato dei contadini nel cuore delle Dolomiti. Rappresenta l'agricoltura, l'uso cosciente delle risorse naturali e la conoscenza nella creazione dei nostri prodotti come ci hanno insegnato i nostri antenati. Dallo speck ai formaggi di mucca o di capra, dalle erbe al vino di miele, dalla farina alla grappa, dalla ceramica al lavoro del legno, dai tessuti al miele: sicuramente c'è qualcosa per tutti."
            },
            Events: {
                title: "Eventi in Programma",
                eventTile: "AGRICOLART Market",
                atText: "a",
                directions: "Indicazioni",
                days: "Giorni",
                hours: "Ore",
                minutes: "Minuti",
                noEvents: "Non ci sono eventi prossimamente."
            },
            Members: {
                title: "I nostri membri",
                visitWebsite: "Visita il loro sito web",
            },
            NavBar: {
                home: "Home",
                upcomingEvents: "Eventi in Programma",
                about: "Chi Siamo",
                ourMembers: "I nostri membri"
            }
        }
    }


    if (navigator.language === "de") {
        content = content.German;
    } else if (navigator.language === "it") {
        content = content.Italian;
    } else {
        content = content.English;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={
                    <div className="App">
                        <NavBar content={content.NavBar}/>
                        <Video/>
                        <Events content={content.Events}/>
                        <About content={content.About}/>
                        <Members content={content.Members}/>
                        <Footer/>
                    </div>
                }></Route>
                <Route path="/login" element={
                    <div className="App">
                        <Login />
                    </div>
                }></Route>
                <Route path="/dashboard" element={
                    <div className="App">
                        <Dashboard />
                    </div>
                }></Route>
            </Routes>
        </BrowserRouter>
    );
}


export default App;
